__turbopack_context__.v({
  "artwork": "audio-guide-module-scss-module__OXDMnW__artwork",
  "artworkImage": "audio-guide-module-scss-module__OXDMnW__artworkImage",
  "artworkThumbnail": "audio-guide-module-scss-module__OXDMnW__artworkThumbnail",
  "crdImageWrapper": "audio-guide-module-scss-module__OXDMnW__crdImageWrapper",
  "credits": "audio-guide-module-scss-module__OXDMnW__credits",
  "description": "audio-guide-module-scss-module__OXDMnW__description",
  "descriptionTitle": "audio-guide-module-scss-module__OXDMnW__descriptionTitle",
  "descriptionWrapper": "audio-guide-module-scss-module__OXDMnW__descriptionWrapper",
  "errorWrapper": "audio-guide-module-scss-module__OXDMnW__errorWrapper",
  "has-transcript": "audio-guide-module-scss-module__OXDMnW__has-transcript",
  "inputWrapper": "audio-guide-module-scss-module__OXDMnW__inputWrapper",
  "mainWrapper": "audio-guide-module-scss-module__OXDMnW__mainWrapper",
  "noImageSvg": "audio-guide-module-scss-module__OXDMnW__noImageSvg",
  "noTranscript": "audio-guide-module-scss-module__OXDMnW__noTranscript",
  "plalistSlideTranslationsDarkMode": "audio-guide-module-scss-module__OXDMnW__plalistSlideTranslationsDarkMode",
  "playerWrapper": "audio-guide-module-scss-module__OXDMnW__playerWrapper",
  "playlistExhibitionSlideSubext": "audio-guide-module-scss-module__OXDMnW__playlistExhibitionSlideSubext",
  "playlistShelf": "audio-guide-module-scss-module__OXDMnW__playlistShelf",
  "playlistShelfTitle": "audio-guide-module-scss-module__OXDMnW__playlistShelfTitle",
  "playlistSlideDescription": "audio-guide-module-scss-module__OXDMnW__playlistSlideDescription",
  "playlistSlideTranslations": "audio-guide-module-scss-module__OXDMnW__playlistSlideTranslations",
  "searchIcon": "audio-guide-module-scss-module__OXDMnW__searchIcon",
  "searchSection": "audio-guide-module-scss-module__OXDMnW__searchSection",
  "sponsorLogo": "audio-guide-module-scss-module__OXDMnW__sponsorLogo",
});
